import { useContext, useState } from 'react';
import { Stack, FormControl, TextField, Autocomplete } from '@mui/material';

import CustomModal from '../shared/CustomModal';
import { ApiServicesContext } from '../../context/ApiServicesContext';
import SnackbarUtils from '../../utils/SnackbarUtils';
import { useGlobalFilterStore } from 'stores/filters';
import { Operator } from 'stores/filters';

const GlobalFilterModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const { optionsService } = useContext(ApiServicesContext);

  const { data: zoneOptions, isFetching: zonesIsLoading } = optionsService.getZoneOptions();
  const { data: pwsIdOptions, isFetching: pwsIsLoading } = optionsService.getPWSOptions();

  const globalPropertiesFilter = useGlobalFilterStore.getState().properties.filter;
  const { setPwsIdFilter, setZoneFilter } = useGlobalFilterStore((state: any) => state.properties);

  const globalPwsIdFilter = globalPropertiesFilter?.pwsId[0]?.value || null;
  const globalZoneFilter = globalPropertiesFilter?.zone[0]?.value || null;

  const [pwsIdTextFieldValue, setPwsIdTextFieldValue] = useState(globalPwsIdFilter);
  const [zoneTextFieldValue, setZoneTextFieldValue] = useState(globalZoneFilter);

  return (
    <>
      <CustomModal
        open={open}
        width={600}
        onConfirm={async () => {
          if (zoneTextFieldValue)
            setZoneFilter([{ operator: Operator.eq, value: zoneTextFieldValue }]);
          if (!zoneTextFieldValue) setZoneFilter([]);
          if (pwsIdTextFieldValue)
            setPwsIdFilter([{ operator: Operator.eq, value: pwsIdTextFieldValue }]);
          if (!pwsIdTextFieldValue) setPwsIdFilter([]);

          SnackbarUtils.success('Global Filter Updated.');
          setOpen(false);
        }}
        onCancel={() => {
          setOpen(false);
          setPwsIdTextFieldValue(globalPwsIdFilter);
          setZoneTextFieldValue(globalZoneFilter);
        }}
        onClose={() => {
          setOpen(false);
          setPwsIdTextFieldValue(globalPwsIdFilter);
          setZoneTextFieldValue(globalZoneFilter);
        }}
        content={
          <>
            <h5> Properties </h5>
            <FormControl fullWidth>
              <Stack
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: '10px',
                  width: '100%',
                }}
              >
                <Autocomplete
                  fullWidth
                  id="global-filter-zone"
                  loading={zonesIsLoading}
                  multiple={false} //Explicit multiple={false} prevents TypeScript errors
                  options={zoneOptions?.map((o) => o.label)}
                  value={zoneTextFieldValue}
                  onChange={(_, newValue) => {
                    setZoneTextFieldValue(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      sx={{
                        '& .MuiSelect-outlined': {
                          minHeight: '0 !important',
                        },
                        '& .MuiTypography-root': {
                          lineHeight: 1.2,
                        },
                        marginRight: '10px',
                      }}
                      label={'Zone'}
                      id="zone-global-filter-select"
                    />
                  )}
                />
                <Autocomplete
                  fullWidth
                  id="global-filter-pwsid"
                  loading={pwsIsLoading}
                  multiple={false} //Explicit multiple={false} prevents TypeScript errors
                  options={pwsIdOptions?.map((o) => o.label)}
                  value={pwsIdTextFieldValue}
                  onChange={(_, newValue) => {
                    setPwsIdTextFieldValue(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      sx={{
                        '& .MuiSelect-outlined': {
                          minHeight: '0 !important',
                        },
                        '& .MuiTypography-root': {
                          lineHeight: 1.2,
                        },
                        marginLeft: '10px',
                      }}
                      label={'PWS ID'}
                      id="pws-id-global-filter-select"
                    />
                  )}
                />
              </Stack>
            </FormControl>
          </>
        }
        title={'Global Filters'}
        titlePopupContent={null}
        confirmText={'Apply'}
        cancelText={null}
      />
    </>
  );
};

export default GlobalFilterModal;
